<app-side-menu>
  <div class="ccs-content">
    <app-controladoria-nav></app-controladoria-nav>

    <header class="ccs-header d-flex flex-wrap align-items-center justify-content-between gap-3">
      <div>
        <button type="button" class="btn btn-outline-secondary btn-sm mb-2" (click)="goBack()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar para centros de custo
        </button>
        <h1 class="ccs-title mb-1">
          <i class="fas fa-chart-line me-2"></i>
          Estatísticas consolidadas
        </h1>
        <p class="text-muted mb-0">
          Visão consolidada de orçamento, custo e variação por centro de custo (raiz da hierarquia).
        </p>
      </div>
      <button type="button" class="btn btn-outline-primary" [disabled]="isLoading" (click)="loadStatistics()">
        <i class="fas fa-sync-alt me-2" [class.fa-spin]="isLoading"></i>
        Atualizar
      </button>
    </header>

    <div *ngIf="isLoading" class="text-center py-5">
      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
      <p class="mt-3 text-muted">Calculando estatísticas...</p>
    </div>

    <div *ngIf="error && !isLoading" class="alert alert-danger d-flex justify-content-between align-items-center">
      <span><i class="fas fa-exclamation-triangle me-2"></i>{{ error }}</span>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="loadStatistics()">Tentar novamente</button>
    </div>

    <ng-container *ngIf="statistics && !isLoading && !error">
      <div class="alert alert-info py-2 small mb-3" *ngIf="statistics.warning">
        <i class="fas fa-info-circle me-2"></i>{{ statistics.warning }}
      </div>

      <div class="row g-3 ccs-summary mb-4">
        <div class="col-md-3 col-6">
          <div class="ccs-kpi">
            <span class="ccs-kpi-label">Orçamento total</span>
            <span class="ccs-kpi-value">{{ statistics.summary.totalBudget | currency:'BRL' }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="ccs-kpi">
            <span class="ccs-kpi-label">Custo total</span>
            <span class="ccs-kpi-value">{{ statistics.summary.totalCost | currency:'BRL' }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="ccs-kpi ccs-kpi--danger">
            <span class="ccs-kpi-label">Acima do orçamento</span>
            <span class="ccs-kpi-value">{{ statistics.summary.overBudgetCount }}</span>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="ccs-kpi ccs-kpi--muted">
            <span class="ccs-kpi-label">Centros no relatório</span>
            <span class="ccs-kpi-value">{{ statistics.totalCostCenters || statistics.statistics.length }}</span>
          </div>
        </div>
      </div>

      <div class="ccs-table-card" *ngIf="detailRows.length > 0">
        <app-table
          [title]="tableTitle"
          [data]="detailRows"
          [columns]="columns"
          [loading]="false"
          [showSearch]="true"
          [searchPlaceholder]="'Buscar centro de custo...'"
          [clickable]="true"
          [actions]="actions"
          [enableSorting]="true"
          [clientSideSort]="true"
          (rowClick)="onRowClick($event)"
          (actionClick)="onActionClick($event)">
        </app-table>
      </div>

      <div *ngIf="!detailRows.length" class="text-center py-5 text-muted">
        Nenhuma estatística disponível.
      </div>
    </ng-container>
  </div>
</app-side-menu>
